import { Injectable, NgZone, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

type Sub = { id: number; cb: (dt: number) => void };

@Injectable({ providedIn: 'root' })
export class MarqueeTickerService {
  private subs = new Map<number, Sub>();
  private lastTs = 0;
  private rafId: number | null = null;
  private nextId = 1;

  private zone = inject(NgZone);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  subscribe(cb: (dt: number) => void): () => void {
    if (!this.isBrowser) return () => { };
    const id = this.nextId++;
    this.subs.set(id, { id, cb });
    if (!this.rafId) this.start();
    return () => this.unsubscribe(id);
  }

  private unsubscribe(id: number) {
    this.subs.delete(id);
    if (this.subs.size === 0) this.stop();
  }

  private start() {
    if (!this.isBrowser) return;
    this.lastTs = performance.now();
    this.zone.runOutsideAngular(() => {
      const step = () => {
        const now = performance.now();
        const dt = (now - this.lastTs) / 1000;
        this.lastTs = now;
        if (dt > 0 && dt < 0.5 && this.subs.size) {
          for (const { cb } of [...this.subs.values()]) cb(dt);
        }
        this.rafId = requestAnimationFrame(step);
      };
      this.rafId = requestAnimationFrame(step);
    });
  }

  private stop() {
    if (this.rafId != null) cancelAnimationFrame(this.rafId);
    this.rafId = null;
  }
}
